import { observer } from 'mobx-react';
import * as React from 'react';
import { Range } from 'nomst/Stores/Decision/range';
import { Configuration } from 'nomst/Stores/Configuration/configuration';
import RangePenetration from 'nomst/Components/Decision/rangePenetration';
import CompaRatio from 'nomst/Components/Decision/compaRatio';
import { PayRangeDisplayType } from 'typings/enums';
import './payRange.scss';

interface IPayRangeProps {
    payRange: NullOrUndefined<Range>;
    payAmount: number;
    configuration: Configuration;
    className: string;
    chartClassName: string;
    useCompactPayRange: boolean;
    barHeight: number;
    pointerHeight: number;
}

@observer
export default class PayRange extends React.Component<IPayRangeProps> {
    public render(): React.ReactNode {
        if (!this.props.payRange || this.payRangeIsNotDefined) {
            return this.renderPayRangeNotDefined();
        }

        const {
            payRange,
            payAmount,
            configuration,
            className,
            chartClassName,
            useCompactPayRange,
            barHeight,
            pointerHeight
        } = this.props;

        const { payRangeConfiguration } = configuration;
        if (payRangeConfiguration.displayType === PayRangeDisplayType.CompaRatio) {
            return (
                <CompaRatio
                    payRange={payRange}
                    payAmount={payAmount}
                    compaRatioDisplayFormat={payRangeConfiguration.compaRatioDisplayFormat}
                    format={configuration.format}
                    className={className}
                />
            );
        }

        return (
            <div className={`nomst-pay-range ${className}`}>
                <div className="nomst-pay-range__title">
                    Range Penetration
                </div>
                <RangePenetration
                    payRange={payRange}
                    payAmount={payAmount}
                    format={configuration.format}
                    className={className}
                    chartClassName={chartClassName}
                    useCompactPayRange={useCompactPayRange}
                    barHeight={barHeight}
                    pointerHeight={pointerHeight}
                />
            </div>
        );
    }

    private renderPayRangeNotDefined(): React.ReactNode {
        return (
            <div className="nomst-pay-range nomst-pay-range--not-defined">
                <div className="nomst-pay-range__title">Range Penetration</div>
                <strong className="nomst-pay-range__description">Range is not defined</strong>
            </div>
        );
    }

    private get payRangeIsNotDefined(): boolean {
        const { payRange } = this.props;
        return !payRange
            || payRange.maxRange === 0
            || payRange.minRange >= payRange.maxRange;
    }
}
